/* eslint-disable @typescript-eslint/no-explicit-any */
'use client';

import dynamic from 'next/dynamic';
import { Suspense } from 'react';
import NewsSearchListSkeleton from './NewsSearchListSkeleton';

/**
 *  新聞關鍵字/標籤搜尋列表
 *  /search?q=xxx 頁面元件
 *  /tag/[tag] 頁面元件
 */
const DynamicNewsSearchList = dynamic(() => import('./NewsSearchList'), {
  loading: () => <NewsSearchListSkeleton />,
  ssr: false
});

const DynamicLoadNewsSearchList = (props: any) => {
  return (
    <Suspense>
      <DynamicNewsSearchList {...props} />
    </Suspense>
  )
}

export default DynamicLoadNewsSearchList;
